import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Card, CardContent } from "@/components/ui/card";
import { MessageCircle as Whatsapp } from "lucide-react";
export default function Contatti() {
  return <section data-section-id="227668" id="contact" className="bg-background text-foreground py-16 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center mb-16 opacity-80">
          <div className="w-16 h-px bg-gradient-to-r from-transparent to-accent" />
          <Separator className="bg-accent w-full max-w-lg mx-4 h-[1px]" />
          <div className="w-16 h-px bg-gradient-to-l from-transparent to-accent" />
        </div>

        <Card className="max-w-2xl mx-auto bg-card/50 backdrop-blur-xl border border-accent/30 shadow-xl shadow-black/5 rounded-3xl overflow-hidden relative">
          <div className="absolute inset-0 bg-gradient-to-br from-accent/20 to-transparent pointer-events-none" />
          
          <CardContent className="p-10 md:p-14 text-center flex flex-col items-center justify-center relative z-10">
            <div className="w-14 h-14 rounded-lg bg-accent flex items-center justify-center mb-6 border border-primary/10 shadow-sm shadow-primary/5">
              <Whatsapp className="w-6 h-6 text-primary" strokeWidth={1.5} />
            </div>
            
            <p className="font-default text-lg md:text-xl text-foreground font-medium leading-relaxed tracking-wide">
              Fragen zu Ihrem Wohlbefinden?{" "}
              <Link to="https://wa.me/491713617469?text=Hallo%20Linda,%20ich%20interessiere%20mich%20f%C3%BCr%20eine%20Behandlung." newTab className="inline-flex items-center text-primary hover:text-primary/70 transition-colors font-semibold border-b border-primary/20 hover:border-primary/50 pb-0.5 mt-2 md:mt-0">Kontakt via WhatsApp</Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
}